<main class="canvas-wide">
  <a routerLink="/releases" class="back-link" style="margin-bottom: 12px; display: inline-flex">
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      width="14"
      height="14"
    >
      <path d="m15 18-6-6 6-6" />
    </svg>
    Releases
  </a>

  <div class="admin-head">
    <div>
      <div class="eyebrow">Admin</div>
      <h1>Administration <span class="badge">Admin only</span></h1>
      <p style="color: var(--text-soft); margin-top: 6px">
        Manage who has access and configure releases.
      </p>
    </div>
  </div>

  <!-- Tabs (AC3) -->
  <div class="tabs">
    <a class="tab active" routerLink="/admin">Users &amp; access</a>
    <a class="tab" routerLink="/admin/releases">Manage releases</a>
  </div>

  <section>
    <!-- Toolbar (AC4) -->
    <div class="toolbar">
      <div class="search-input">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="11" cy="11" r="7" />
          <path d="m20 20-3.5-3.5" />
        </svg>
        <input
          type="text"
          placeholder="Search users"
          [value]="search()"
          (input)="search.set($any($event.target).value)"
          aria-label="Search users"
        />
        @if (search()) {
          <button
            type="button"
            class="search-clear"
            aria-label="Clear search"
            title="Clear search"
            (click)="search.set('')"
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M18 6 6 18M6 6l12 12" />
            </svg>
          </button>
        }
      </div>
      <div class="chip-group">
        @for (f of filters; track f.key) {
          <button
            type="button"
            class="chip"
            [class.active]="roleFilter() === f.key"
            (click)="roleFilter.set(f.key)"
          >
            {{ f.label }} <span class="count">{{ counts()[f.key] }}</span>
          </button>
        }
      </div>
      <button class="invite-btn" type="button" (click)="openInvite()">
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2.5"
          width="14"
          height="14"
        >
          <path d="M12 5v14M5 12h14" />
        </svg>
        Invite user
      </button>
    </div>

    <!-- Users table (AC5) -->
    <div class="users-table">
      <div class="users-thead">
        <div></div>
        <div>Name</div>
        <div>Email</div>
        <div>Role</div>
        <div>Status</div>
        <div>Last active</div>
        <div></div>
      </div>

      @if (isLoading()) {
        @for (row of skeletonRows; track row) {
          <div class="users-tr skel-tr" aria-hidden="true">
            <span class="skel skel-avatar"></span>
            <span class="skel skel-line"></span>
            <span class="skel skel-line short"></span>
            <span class="skel skel-pill"></span>
            <span class="skel skel-status"></span>
            <span class="skel skel-line short"></span>
            <span class="skel skel-kebab"></span>
          </div>
        }
      } @else if (filteredUsers().length === 0) {
        <div class="empty-row">No users match your filters.</div>
      } @else {
        @for (u of filteredUsers(); track u.userId) {
          <div class="users-tr">
            <div class="avatar size-32" [class.is-empty]="u.status === 'Invited'">
              {{ initials(u) }}
            </div>
            <div>
              <div class="name">
                {{ u.firstName }} {{ u.lastName }}
                @if (isSelf(u)) {
                  <span class="you">(you)</span>
                }
              </div>
            </div>
            <div class="email">{{ u.email }}</div>
            <div>
              <span class="role-pill {{ u.role || '' | lowercase }}">{{ u.role }}</span>
            </div>
            <div>
              <span class="status-dot-row {{ u.status || '' | lowercase }}">
                <span class="dot {{ u.status || '' | lowercase }}"></span>{{ u.status }}
              </span>
            </div>
            <div class="last">{{ lastActiveLabel(u) }}</div>

            <button
              class="row-menu"
              type="button"
              aria-label="More actions"
              [cdkMenuTriggerFor]="rowMenu"
            >
              <svg viewBox="0 0 24 24" fill="currentColor" width="14" height="14">
                <circle cx="5" cy="12" r="2" />
                <circle cx="12" cy="12" r="2" />
                <circle cx="19" cy="12" r="2" />
              </svg>
            </button>

            <ng-template #rowMenu>
              <div class="popover" cdkMenu>
                @if (!isSelf(u)) {
                  <div class="popover-label">Change role</div>
                  @for (r of roles; track r) {
                    @if (r !== u.role) {
                      <button class="popover-item" cdkMenuItem (click)="changeRole(u, r)">
                        {{ r }}
                      </button>
                    }
                  }
                  <div class="popover-divider"></div>
                }

                @if (u.status === 'Invited') {
                  <button class="popover-item" cdkMenuItem (click)="resendInvite(u)">
                    Resend invite
                  </button>
                }

                @if (!isSelf(u)) {
                  @if (u.status === 'Inactive') {
                    <button class="popover-item" cdkMenuItem (click)="setActive(u, true)">
                      Reactivate
                    </button>
                  } @else {
                    <button class="popover-item" cdkMenuItem (click)="setActive(u, false)">
                      Deactivate
                    </button>
                  }
                  <button class="popover-item danger" cdkMenuItem (click)="remove(u)">
                    Remove user
                  </button>
                }
              </div>
            </ng-template>
          </div>
        }
      }
    </div>
  </section>
</main>
